export default __webpack_public_path__ + "static/media/cups_pints_quarts_popup.6d5983f6.png";